import { render, staticRenderFns } from "./modalClaimError.vue?vue&type=template&id=adb09a70&"
import script from "./modalClaimError.vue?vue&type=script&lang=js&"
export * from "./modalClaimError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports